/* eslint-disable unused-imports/no-unused-vars */
import * as yup from 'yup';

declare module 'yup' {
  interface NumberSchema<TType, TContext, TDefault, TFlags> {
    emptyAsUndefined(): this;
  }

  interface ObjectSchema<
    TIn extends yup.Maybe<yup.AnyObject>,
    TContext = yup.AnyObject,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TDefault = any,
    TFlags extends yup.Flags = '',
  > {
    atLeastOneOf(fieldsList: string[]): this;
  }
}

yup.addMethod(yup.number, 'emptyAsUndefined', function () {
  return this.transform((value: number, originalValue) => (String(originalValue)?.trim() ? value : undefined));
});

// https://github.com/jquense/yup/issues/248#issuecomment-3179649091
yup.addMethod(yup.object, 'atLeastOneOf', function (fieldsList: string[]) {
  return this.test({
    exclusive: true,
    // eslint-disable-next-line no-template-curly-in-string
    message: '${path} must have at least one of these keys: ${keys}',
    name: 'atLeastOneOf',
    params: { keys: fieldsList.join(', ') },
    test: function (value) {
      if (value == null || fieldsList.some((f) => !!value[f])) {
        return true;
      }

      const errors = fieldsList.map((field) =>
        this.createError({
          message: `At least one of these fields must be provided.`,
          path: `${this.path}.${field}`,
        })
      );

      return new yup.ValidationError(errors);
    },
  });
});
